import { AxiosResponse } from 'axios';
import { BaseService } from '@services/route.service';
import { WhatsappTemplateRequest } from './requests/whatsapp-template.request';
import {
    LeadVariableCategory,
    WhatsappTemplateListResponse,
} from './responses/whatsapp-template.response';

export class WhatsappTemplateService extends BaseService {
    protected get resourceName(): string {
        return 'crm/whatsapp-templates';
    }

    public async getList(): Promise<AxiosResponse<{ data: WhatsappTemplateListResponse }>> {
        return await this.get('');
    }

    public async getVariables(): Promise<AxiosResponse<{ data: LeadVariableCategory[] }>> {
        return await this.get('variables');
    }

    public async testConnection(): Promise<AxiosResponse<{ data: { ok: boolean; count: number } }>> {
        return await this.post({}, 'test');
    }

    public async create(body: WhatsappTemplateRequest): Promise<AxiosResponse<unknown>> {
        return await this.post(body);
    }

    // O componentsJson volta como veio da Meta: ela substitui o array inteiro e os botões sumiriam.
    public async update(
        metaTemplateId: string,
        body: WhatsappTemplateRequest,
        componentsJson: string | null
    ): Promise<AxiosResponse<unknown>> {
        const suffix = componentsJson
            ? `?componentsJson=${encodeURIComponent(componentsJson)}`
            : '';

        return await this.put(`${metaTemplateId}${suffix}`, body);
    }

    public async deleteByName(name: string): Promise<AxiosResponse<void>> {
        return await this.delete(encodeURIComponent(name));
    }
}
